import { createSlice } from '@reduxjs/toolkit';
import {
  fetchIncomingUpsells,
  fetchPendingUpsellsCount,
  manageUpsellRequests,
  assignDeliveriesToPartner,
} from './upsellingThunks';

const initialState = {
  incoming: [],
  total: 0,
  pendingCount: 0,
  isLoading: false,
  // Kept apart from `isLoading` so accepting a request does not blank the table
  // underneath it.
  isSubmitting: false,
  error: null,
  filters: {
    page: 1,
    rowsPerPage: 20,
  },
};

const upsellingSlice = createSlice({
  name: 'upselling',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setPage: (state, action) => {
      state.filters.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.filters.rowsPerPage = action.payload;
      state.filters.page = 1;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchIncomingUpsells.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchIncomingUpsells.fulfilled, (state, action) => {
        state.isLoading = false;
        state.incoming = action.payload.results;
        state.total = action.payload.count;
      })
      .addCase(fetchIncomingUpsells.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      .addCase(fetchPendingUpsellsCount.fulfilled, (state, action) => {
        state.pendingCount = action.payload;
      })

      .addCase(manageUpsellRequests.pending, (state) => {
        state.isSubmitting = true;
        state.error = null;
      })
      .addCase(manageUpsellRequests.fulfilled, (state) => {
        state.isSubmitting = false;
      })
      .addCase(manageUpsellRequests.rejected, (state, action) => {
        state.isSubmitting = false;
        state.error = action.payload;
      })

      // The assignment result is held by the modal that triggered it, not here:
      // it is a one-off report, not state the rest of the app reads.
      .addCase(assignDeliveriesToPartner.pending, (state) => {
        state.isSubmitting = true;
      })
      .addCase(assignDeliveriesToPartner.fulfilled, (state) => {
        state.isSubmitting = false;
      })
      .addCase(assignDeliveriesToPartner.rejected, (state) => {
        state.isSubmitting = false;
      });
  },
});

export const { setFilters, setPage, setRowsPerPage, clearError } = upsellingSlice.actions;

export default upsellingSlice.reducer;
